import React from 'react';
import EGaugeDashboard from '../components/EGaugeDashboard';
import { getSiteById } from '../config/sites';

const KalapuyaCTE = () => {
  const siteConfig = getSiteById('kalapuya-cte');
  return <EGaugeDashboard config={siteConfig} />;
};

export default KalapuyaCTE;
